<template>
  <v-dialog v-model="intDialogVisible" max-width="900px" class="addValueModal addComment connectSoon" persistent>

    <v-card>
      <div class="row inner">
        <div class="col-12 text-center">
          <span class="fs24 fwbold tblue">Welcome {{who}}</span><br/>
          <!-- <span class="fs24 fwbold">You will be connected soon with </span> -->
          <div class="text-center fs20" v-if="client_name">
            To join {{client_name}} innovation ecosystem, let’s first create your innovator profile.
            <br/><br/>
            Our tools will then make it easier for you to manage opportunities and convert them into more scalable innovation partnerships.
          </div>
          <div v-else class="text-center fs20">
            To join our innovation ecosystem, let’s first create your innovator profile.
            <br/><br/>
            Our tools will then make it easier for you to manage opportunities and convert them into more scalable innovation partnerships.
          </div>
          <!-- <div class="myaccountlogo mt20" v-if="partner_logo">
            <img :src="this.apiUrl+'/get_image/'+partner_logo"   alt="" class="myaccountlogoImage">
          </div> -->

        </div>

        <div class="vactions mt50">
          <div class="checkbox-wrapper-21">
            <label class="control control--checkbox">
              By signing in you accept our <a href="https://www.innopearl.ch/data-policy" target="_blank" class="tblue nodeco">Data Policy </a>
              <input type="checkbox" v-model="data_policy" />
              <div class="control__indicator"></div>
            </label>
          </div>
          <button class="addValue" @click="submit" :disabled="!data_policy">
            Start
          </button>
          <small class="tblue">Powered by Innopearl ©</small>
        </div>
      </div>


    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/tools/api';
export default {
  props: {
    dialogVisible: Boolean,
    partner_logo : String,
    client_name:String,
    who: String,
    sid : String,
  },
  data () {
    return {
apiUrl: process.env.VUE_APP_API_URL,
      data_policy:false,
          logo : null,
    }

  },
  methods:{
    submit(){
      api.post(this.apiUrl+'/data_policy_start/'+this.sid).then((r) => {
          console.log(r);
        this.$emit('confirmed',true)
      });

    },
    close(){
              this.loadLogo = false;
        this.$emit('close',false)
    }
  },
  computed: {
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes
        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                       this.$emit('close',false)
             }
      }
    }
  },


}
</script>

<style media="screen" scoped>
  .addValueModal .v-card{
    padding:10px;
  }
  .addValueModal .v-field__outline{
    display:none;
  }
  .formName{
    text-align: left;
    font-size: 21px;
    line-height: 25px;
    color: #3783C5;
  }
  .addValueModal button{
    border: 1px solid #3783C5;
    border-radius: 50px;
    opacity: 1;
    padding: 7px 18.5px;
    color:#3783C5;
    margin: 5px;
  }

    .addValueModal button.addValue{
      border: 1px solid #B38D2F;

      background:#B38D2F;
      color:#fff;
    }

    .addValueModal button.addValue:disabled{
opacity:.8
    }
    .addValueInput input{
      border: 1px solid #DDDDDD;
    }
  .addComment textarea{
    width: 100%;
margin: 0;
border: 1px solid #DDDDDD;
mask-image: none !important;
  }
  .v-card-title{
    white-space: normal !important;
  }
  .fs24{
    font-size:24px;
  }
  .fwbold{
    font-weight: 500;
  }
  .inner{
    padding:20px;
  }
  .mt20{
    margin-top:20px;
  }
  .mt50{
    margin-top: 50px;
  }
  .myaccountlogoImage{
    width:200px;
    height:100px;
    object-fit: contain;
    object-position:  center;
    margin: auto;
  }
.vactions{
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap:10px;
}



  .checkbox-wrapper-21 .control {
    display: block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 12px;
    line-height: 20px;
  }
  .checkbox-wrapper-21 .control input {
    position: absolute;
    z-index: -1;
    opacity: 0;
  }
  .checkbox-wrapper-21 .control__indicator {
    position: absolute;
    top: 2px;
    left: 0;
    height: 20px;
    width: 20px;
    background: #FFF;
    border:1px solid #3783C5;
  }
  .checkbox-wrapper-21 .control:hover input ~ .control__indicator,
  .checkbox-wrapper-21 .control input:focus ~ .control__indicator {
    background: #FFF;
  }
  .checkbox-wrapper-21 .control input:checked ~ .control__indicator {
    background: #3783C5;
  }
  .checkbox-wrapper-21 .control:hover input:not([disabled]):checked ~ .control__indicator,
  .checkbox-wrapper-21 .control input:checked:focus ~ .control__indicator {
    background: #3783C5;
  }
  .checkbox-wrapper-21 .control input:disabled ~ .control__indicator {
    background: #e6e6e6;
    opacity: 0.6;
    pointer-events: none;
  }
  .checkbox-wrapper-21 .control__indicator:after {
    content: '';
    position: absolute;
    display: none;
  }
  .checkbox-wrapper-21 .control input:checked ~ .control__indicator:after {
    display: block;
  }
  .checkbox-wrapper-21 .control--checkbox .control__indicator:after {
    left: 7px;
      top: 4px;
      width: 5px;
      height: 8px;
      border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
  .checkbox-wrapper-21 .control--checkbox input:disabled ~ .control__indicator:after {
    border-color: #7b7b7b;
  }

  .connectSoon .v-card{
    box-shadow: none;
  }

  .tblue{
    color:#3783C5;
  }

  .fs20{
    font-size:20px;

  }
</style>

<style media="screen">
  .connectSoon .v-overlay__scrim{
    background:#FFF;
    opacity:1;
  }
</style>
